import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCodeSectionsByIdsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input'];
}>;


export type GetCodeSectionsByIdsQuery = { __typename?: 'query_root', code_sections: Array<{ __typename?: 'code_sections', id: any, section_number: string, title?: string | null, body: string, commentary?: string | null, page_number?: number | null, chapter_number?: string | null, chapter_title?: string | null, code_book: { __typename?: 'code_books', id: any, abbreviation: string, edition_year?: number | null, title: string, book_type: string, source_file_url?: string | null } }> };


export const GetCodeSectionsByIdsDocument = gql`
    query getCodeSectionsByIds($ids: [uuid!]!) {
  code_sections(where: {id: {_in: $ids}}, order_by: {sort_key: asc}) {
    id
    section_number
    title
    body
    commentary
    page_number
    chapter_number
    chapter_title
    code_book {
      id
      abbreviation
      edition_year
      title
      book_type
      source_file_url
    }
  }
}
    `;

/**
 * __useGetCodeSectionsByIdsQuery__
 *
 * To run a query within a React component, call `useGetCodeSectionsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCodeSectionsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCodeSectionsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetCodeSectionsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetCodeSectionsByIdsQuery, GetCodeSectionsByIdsQueryVariables> & ({ variables: GetCodeSectionsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCodeSectionsByIdsQuery, GetCodeSectionsByIdsQueryVariables>(GetCodeSectionsByIdsDocument, options);
      }
export function useGetCodeSectionsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCodeSectionsByIdsQuery, GetCodeSectionsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCodeSectionsByIdsQuery, GetCodeSectionsByIdsQueryVariables>(GetCodeSectionsByIdsDocument, options);
        }
export function useGetCodeSectionsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCodeSectionsByIdsQuery, GetCodeSectionsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCodeSectionsByIdsQuery, GetCodeSectionsByIdsQueryVariables>(GetCodeSectionsByIdsDocument, options);
        }
export type GetCodeSectionsByIdsQueryHookResult = ReturnType<typeof useGetCodeSectionsByIdsQuery>;
export type GetCodeSectionsByIdsLazyQueryHookResult = ReturnType<typeof useGetCodeSectionsByIdsLazyQuery>;
export type GetCodeSectionsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetCodeSectionsByIdsSuspenseQuery>;
export type GetCodeSectionsByIdsQueryResult = Apollo.QueryResult<GetCodeSectionsByIdsQuery, GetCodeSectionsByIdsQueryVariables>;